import { IComponentOptions } from "angular";
import templateUrl from "./meridian-id-movement-confirmed.component.html";

export const MeridianIdMovementConfirmedModalComponent: IComponentOptions = {
    templateUrl,
    bindings: {
        resolve: "<",
        close: "&",
        dismiss: "&"
    }
};

export const MeridianIdMovementConfirmedModal = {
    component: "apexMeridianIdMovementConfirmedModal",
    windowClass: 'xx-dialog pagespinner',
    size: 'sm',
    backdrop: 'static'
};
